export default __webpack_public_path__ + "static/media/18.b1bda73e.jpeg";